// src/components/layout/OfflineNotifier.tsx
import { useEffect } from 'react';
import { toast } from 'sonner';

export const OfflineNotifier = () => {
  useEffect(() => {
    const handleOnline = () => {
      toast.success("You are back online!", {
        position: 'bottom-center',
        duration: 3000,
      });
    };

    const handleOffline = () => {
      toast.warning("You are currently offline.", {
        position: 'bottom-center',
        duration: 5000,
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return null; // This component does not render anything itself
};